import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Checkbox,
} from "@mui/material";
import commonapihandler from "../../common/commonapihandler";
import { getHubName } from "../../api/api";
import Inquirydetailstab from "./Inquirydetailstab";
import formatDateAndTime from "../../common/formatDateAndTime";
import moment from "moment";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import getactions from "../../common/getactions";
import toast from "react-hot-toast";
import { BlinkBlur } from "react-loading-indicators";
import { useSelector } from "react-redux";
import AgentassignDialog from "./Agentassigndialog";

function createData(
  id,
  source,
  inquiryID,
  bookingType,
  bookingstatus,
  startDate,
  endDate,
  isSalesAgentAssigned,
  assignedTo,
  inquiredin,
  vehicleName,
  vehicleNo,
  createdAt,
  city,
  hub,
  customername,
  customermobile,
  customerEmail,
  amount,
  // action
) {
  return {
    id,
    source,
    inquiryID,
    bookingType,
    bookingstatus,
    startDate,
    endDate,
    isSalesAgentAssigned,
    assignedTo,
    inquiredin,
    vehicleName,
    vehicleNo,
    createdAt,
    city,
    hub,
    customername,
    customermobile,
    customerEmail,
    amount,
    // action,
  };
}

const Viewallinquiry = ({ setActiveItem }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const citiesList = useSelector((state) => state?.cities?.citiesData);
  const isMobile = useMediaQuery("(max-width:768px)");
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  const isSystemUserDataList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const [page, setPage] = useState(0);
  const [openTab, setOpenTab] = useState(false);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [allBookings, setAllBookings] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const bookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  delete bookingStatus?.inverted;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  let bookingTypesDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  delete bookingTypesDuplicate?.inverted;
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [copied, setCopied] = useState(false);
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const [bookingstatusVal, setBookingStatusVal] = useState(
    fleetBookingStatus?.inverted?.inquiry,
  );
  const [selectedSearchButton, setSelectedSearchButton] = useState("");
  const [searchValues, setSearchValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateFitlerBy, setDateFilterBy] = useState("createdAt");
  const [isReset, setIsReset] = useState(false);
  const [sourceVal, setSourceVal] = useState("");
  const [selected, setSelected] = useState([]);
  const [agentAssignDialog, setAgentAssignDialog] = useState(false);
  const [bookingTypesStatus, setBookingTypes] = useState(null);
  const [cityVal, setCityVal] = useState(null);

  const filteredKeys = Object.keys(bookingStatus).filter(
    (key) =>
      bookingStatus[key].includes("Inquiry") ||
      bookingStatus[key].includes("Inquiry Closed"),
  );

  const filteredArray = Object.entries(bookingStatus)
    .filter(([key, value]) => value === "Inquiry" || value === "Inquiry Closed")
    .map(([key, value]) => ({ key, value }));

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100")
        setGetAllHubsListData(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const columns = [
    { id: "id", label: "Id", minWidth: 70, align: "left" },
    { id: "source", label: "Source", minWidth: 100, align: "left" },
    { id: "inquiryID", label: "Inquiry ID", minWidth: 250, align: "left" },
    {
      id: "bookingstatus",
      label: "Booking Status",
      minWidth: 150,
      align: "center",
    },
    {
      id: "bookingType",
      label: "Booking Type",
      minWidth: 250,
      align: "center",
    },
    { id: "startDate", label: "Start Date", minWidth: 200, align: "right" },
    { id: "endDate", label: "End Date", minWidth: 200, align: "right" },
    {
      id: "isSalesAgentAssigned",
      label: "Is Sales Agent Assigned",
      minWidth: 190,
      align: "right",
    },
    { id: "assignedTo", label: "Assigned To", minWidth: 160, align: "right" },
    { id: "inquiredin", label: "Inquired In", minWidth: 100, align: "right" },
    { id: "vehicleName", label: "Vehicle Name", minWidth: 200 },
    { id: "vehicleNo", label: "Vehicle No", minWidth: 200 },
    { id: "createdAt", label: "Created At", minWidth: 200, align: "right" },
    { id: "city", label: "City", minWidth: 100, align: "right" },
    { id: "hub", label: "Hub", minWidth: 130, align: "right" },
    {
      id: "customername",
      label: "Customer Name",
      minWidth: 150,
      align: "right",
    },
    {
      id: "customermobile",
      label: "Customer Mobile",
      minWidth: 150,
      align: "right",
    },
    {
      id: "customerEmail",
      label: "Customer Email",
      minWidth: 150,
      align: "right",
    },
    {
      id: "amount",
      label: "Amount",
      minWidth: 120,
      align: "right",
      format: (value) => value?.toFixed(2),
    },
    // { id: "action", label: "Action", minWidth: 90, align: "right" },
  ];

  const rows =
    allBookings?.map((item) =>
      createData(
        item?.id,
        camelToNormal(item?.source),
        item?.inquiryCode,
        (bookingTypes[item?.bookingType] ||
          bookingTypes[Number(bookingTypes?.inverted?.dailyRental)]) +
          `(${moment(item?.bookTo).diff(moment(item?.bookFrom), "hours") < 24 ? `${moment(item?.bookTo).diff(moment(item?.bookFrom), "hours")} hours` : `${Math.floor(moment(item?.bookTo).diff(moment(item?.bookFrom), "hours") / 24)} days`})`,
        fleetBookingStatus[item?.bookingStatus] || "-",
        formatDateAndTime(item?.bookFrom),
        formatDateAndTime(item?.bookTo),
        item?.isSalesAgentAssigned ? "Yes" : "No",
        isSystemUserDataList.find((user) => user.id === item?.assignedAgent)
          ?.name || "-",
        `${moment().diff(moment(item?.createdAt), "days") || 0} days`,
        item?.vehicleName || "-",
        item?.vehicleRegistrationNo || "/",
        formatDateAndTime(item?.createdAt),
        cities[item?.cityId],
        getAllHubsListData.find((hub) => hub?.id === item?.hubId)?.hubName ||
          "-",
        item?.customerName,
        item?.customerMobile,
        item?.customerEmail,
        "₹ " + item?.costToCustomer,
        // "View"
      ),
    ) || [];

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getCityNames();
    getAllBookings(0, rowsPerPage, true); // skip validation on mount
    getAllHubsList();
  }, []);

  useEffect(() => {
    if (agentAssignDialog) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [agentAssignDialog]);

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const handleHubChange = (event) => {
    setHub(event.target.value);
  };

  const getAllBookings = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
    skipValidation = false,
    reset = false,
    overrides = {},
  ) => {
    const offset = customPage * customRowsPerPage;
    const selectionRangeLocal = overrides.selectionRange || selectionRange;
    const bookingstatusLocal =
      overrides.bookingstatusVal !== undefined
        ? overrides.bookingstatusVal
        : bookingstatusVal;
    const dateFilterByLocal = overrides.dateFilterBy || dateFitlerBy;
    const selectedSearchButtonLocal =
      overrides.selectedSearchButton !== undefined
        ? overrides.selectedSearchButton
        : selectedSearchButton;
    const searchValuesLocal =
      overrides.searchValues !== undefined
        ? overrides.searchValues
        : searchValues;
    const sourceValuesLocal =
      overrides.sourceVal !== undefined ? overrides.sourceVal : sourceVal;

    let formatStart = moment(selectionRangeLocal?.startDate)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm");
    let formatEnd = moment(selectionRangeLocal?.endDate)
      .endOf("day")
      .format("YYYY-MM-DDTHH:mm");

    if (selectedSearchButtonLocal) {
      if (!skipValidation) {
        if (!selectedSearchButtonLocal) {
          return toast.error("Please select the search by category", {
            position: "top-center",
            style: {
              background: "white", // override background
              color: "red",
              fontWeight: "medium",
              marginBottom: "40px",
            },
          });
        }
        if (!searchValuesLocal) {
          return toast.error("Please enter the values to search", {
            position: "top-center",
            style: {
              background: "white", // override background
              color: "red",
              fontWeight: "medium",
              marginBottom: "40px",
            },
          });
        }
      }
    }

    let query = ``;

    if (profile?.roles.includes(Number(catalogRoles))) {
      query += `&cityId=${profile?.cityId}`;
    } else {
      if (cityVal) {
        query += `&cityId=${cityVal}`;
      }
    }

    if (dateFilterByLocal && formatStart && formatEnd) {
      query += `&dateType=${dateFilterByLocal}&startDate=${formatStart}&endDate=${formatEnd}`;
    } else if (!dateFilterByLocal && !skipValidation) {
      return toast.error("Please select the date filter type", {
        position: "top-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginTop: "60px",
        },
      });
    }

    if (sourceValuesLocal && sourceValuesLocal !== "All") {
      query += `&source=${sourceValuesLocal}`;
    }

    if (selectedSearchButtonLocal === "contactEmail") {
      query += `&customerEmail=${searchValuesLocal}`;
    } else if (selectedSearchButtonLocal === "customerContactNo") {
      query += `&customerMobile=${searchValuesLocal}`;
    } else if (selectedSearchButtonLocal === "inquiryCode") {
      query += `&inquiryId=${searchValuesLocal}`;
    } else if (selectedSearchButtonLocal === "vehicleRegistrationNo") {
      query += `&vehicleRegistrationNo=${searchValuesLocal}`;
    }
    // else if (selectedSearchButtonLocal === "source") {
    //   query += `&source=${searchValuesLocal}`;
    // }

    // if (!isReset) {
    // if (bookingstatusVal) {
    //   query += `&bookingStatus=${bookingstatusVal}`;
    // } else if (filteredKeys) {
    //   query += `&bookingStatus=[${filteredKeys}]`;
    // }
    // }

    if (bookingstatusLocal) {
      query += `&bookingStatus=${bookingstatusLocal}`;
    }

    if (bookingTypesStatus) {
      query += `&bookingType=${bookingTypesStatus}`;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/advancesearch/inquiry?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setIsReset(false);
        setAllBookings(data?.dataValues?.rows);
        setTotalCount(data?.dataValues?.count || 0);
      }
      return data;
    } catch (error) {
      console.error("Error fetching Hub Names:", error);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setLoading(false);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getAllBookings(0, newRowsPerPage, true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllBookings(newPage, rowsPerPage, true);
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  const handleReset = () => {
    const newRange = {
      startDate: oneMonthAgo,
      endDate: today,
      key: "selection",
    };
    const defaultBookingStatus = fleetBookingStatus?.inverted?.inquiry;
    setBookingStatusVal(defaultBookingStatus);
    setSourceVal("");
    setSelectionRange(newRange);
    setSelectedSearchButton("");
    setSearchValues("");
    setDateFilterBy("createdAt");
    setCityVal(null);
    setBookingTypes("");
    setPage(0);
    getAllBookings(0, rowsPerPage, true, false, {
      selectionRange: newRange,
      bookingstatusVal: defaultBookingStatus,
      selectedSearchButton: "",
      searchValues: "",
      dateFilterBy: "createdAt",
      sourceVal: "",
    });
  };

  const searchByFilter = [
    {
      label: "Inquiry Id",
      value: "inquiryCode",
    },
    {
      label: "Customer Email",
      value: "contactEmail",
    },
    {
      label: "Customer Contact",
      value: "customerContactNo",
    },
    // {
    //   label: "Source",
    //   value: "source",
    // },
    // {
    //   label: "Vehicle Registration",
    //   value: "vehicleRegistrationNo",
    // },
  ];

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelected(rows);
    } else {
      setSelected([]);
    }
  };

  const handleSelectRow = (event, row) => {
    event.stopPropagation();

    const isSelected = selected.some((item) => item.id === row.id);

    let newSelected;

    if (isSelected) {
      newSelected = selected.filter((item) => item.id !== row.id);
      setSelected(newSelected);
    } else {
      if (selected.length >= 10) {
        toast.error("You can select up to 10 inquiries for assignment");
        return;
      }
      newSelected = [...selected, row];
      setSelected(newSelected);
    }
  };

  const handleAssignInquiries = () => {
    if (selected.length > 10) {
      toast.error("Please select 10 inquiry to assign", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
        },
      });
      return;
    } else {
      setAgentAssignDialog(true);
    }
  };

  return (
    <>
      {agentAssignDialog && (
        <AgentassignDialog
          setAgentAssignDialog={setAgentAssignDialog}
          agentAssignDialog={agentAssignDialog}
          selectedInquiries={selected}
          getAllBookings={getAllBookings}
          setSelected={setSelected}
        />
      )}

      {!openTab ? (
        <>
          <Box p={isMobile ? 2 : 2}>
            <div className="flex justify-between">
              <h2 className="text-2xl font-semibold">Booking Inquiry Lists</h2>

              <div className="flex gap-2">
                {selected.length > 0 && (
                  <div className="flex justify-end px-4 mt-2">
                    <button
                      onClick={() => {
                        handleAssignInquiries();
                      }}
                      className="px-5 py-2 bg-teal-600 text-white rounded-lg text-md hover:bg-teal-700"
                    >
                      Assign Inquiries
                    </button>
                  </div>
                )}
                <button
                  onClick={() => {
                    getAllBookings(0, rowsPerPage, true);
                  }}
                  class="p-5 rounded-full backdrop-blur-lg border border-green-500/20 bg-gradient-to-tr from-white/60 to-white/40 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 hover:scale-110 hover:rotate-2 active:scale-95 active:rotate-0 transition-all duration-300 ease-out cursor-pointer hover:border-green-500/50 hover:bg-gradient-to-tr hover:from-green-500/10 hover:to-white/40 group relative overflow-hidden"
                >
                  <div class="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>
                  <div class="relative z-10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100"
                      height="100"
                      viewBox="0 0 30 30"
                      className="w-4 h-4"
                    >
                      <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                    </svg>
                  </div>
                </button>
              </div>
            </div>
            <Box
              display="flex"
              flexDirection="column"
              p={2}
              borderRadius={2}
              boxShadow={3}
              mt={2}
              mb={2}
              sx={{ backgroundColor: "white" }}
            >
              <div className="grid grid-cols-12 mt-2">
                {/* <h1 className="mt-2 col-span-1 text-start">Search By :</h1> */}

                <div className="col-span-12 flex gap-4">
                  <FormControl fullWidth size="small">
                    <InputLabel id="hub-select-label">Date Filter</InputLabel>
                    <Select
                      labelId="hub-select-label"
                      id="hub-select"
                      value={dateFitlerBy}
                      onChange={(e) => {
                        setDateFilterBy(e.target.value);
                      }}
                    >
                      <MenuItem value="createdAt">Created At</MenuItem>
                      <MenuItem value="bookFrom">Start Date</MenuItem>
                      <MenuItem value="bookTo">End Date</MenuItem>
                    </Select>
                  </FormControl>

                  <DaterangePicker
                    selectionRange={selectionRange}
                    setSelectionRange={setSelectionRange}
                  />

                  <FormControl fullWidth size="small">
                    <InputLabel id="city-select-label">
                      Booking Status
                    </InputLabel>
                    <Select
                      labelId="city-select-label"
                      id="city-select"
                      value={bookingstatusVal}
                      onChange={(e) => setBookingStatusVal(e.target.value)}
                      MenuProps={{
                        PaperProps: { sx: { maxHeight: 200 } },
                      }}
                    >
                      {filteredArray &&
                        filteredArray.map((item) => (
                          <MenuItem
                            key={item.key}
                            value={item.key}
                            className="text-sm"
                          >
                            {item.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth size="small">
                    <InputLabel id="city-select-label">City</InputLabel>
                    <Select
                      labelId="city-select-label"
                      id="city-select"
                      value={cityVal}
                      onChange={(e) => setCityVal(e.target.value)}
                    >
                      {citiesList &&
                        Object.entries(citiesList).map(([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth size="small">
                    <InputLabel id="resntal-select-label">
                      Rental Types
                    </InputLabel>
                    <Select
                      labelId="resntal-select-label"
                      id="resntal-select"
                      value={bookingTypesStatus}
                      onChange={(e) => {
                        setPage(0);
                        setBookingTypes(e.target.value);
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200, // Limits dropdown height (optional)
                          },
                        },
                      }}
                    >
                      {bookingTypesDuplicate &&
                        Object.entries(bookingTypesDuplicate).map(
                          ([key, value]) => (
                            <MenuItem
                              sx={{
                                minHeight: 20, // Smaller height
                                paddingY: 0.5, // Compact vertical padding
                                fontSize: "0.8rem", // Smaller font (optional)
                              }}
                              key={key}
                              value={key}
                            >
                              {value}
                            </MenuItem>
                          ),
                        )}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth size="small">
                    <InputLabel id="status-select-label">Source</InputLabel>
                    <Select
                      labelId="status-select-label"
                      id="status-select"
                      value={sourceVal}
                      onChange={(e) => setSourceVal(e.target.value)}
                      MenuProps={{
                        PaperProps: { sx: { maxHeight: 200 } },
                      }}
                    >
                      <MenuItem key="All" value="All" className="text-sm">
                        All
                      </MenuItem>
                      <MenuItem
                        key="mobileapp"
                        value="mobileapp"
                        className="text-sm"
                      >
                        Mobile App
                      </MenuItem>
                      <MenuItem
                        key="website"
                        value="website"
                        className="text-sm"
                      >
                        Website
                      </MenuItem>
                      <MenuItem key="admin" value="admin" className="text-sm">
                        Admin
                      </MenuItem>
                    </Select>
                  </FormControl>

                  {searchByFilter.map((item, index) => {
                    const isActive = item?.value === selectedSearchButton;
                    return (
                      <div key={index}>
                        <button
                          onClick={() => {
                            setSearchValues(null);
                            setSelectedSearchButton(item?.value);
                          }}
                          className={`h-[40px] w-40 rounded-xl flex items-center justify-center transition-transform duration-200 active:scale-[0.95] border
                          ${
                            isActive
                              ? "bg-[linear-gradient(45deg,#efad21,#ffd60f)] border-transparent text-white font-medium text-md shadow-md"
                              : "bg-white border-black text-black hover:bg-gray-100"
                          }`}
                        >
                          <span className="font-normal leading-none transition-all duration-200">
                            {item?.label}
                          </span>
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="mt-8 grid grid-cols-12 gap-16">
                <div className="col-span-10">
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label="Enter the value to search"
                    variant="standard"
                    value={searchValues}
                    onChange={(e) => {
                      setSearchValues(e.target.value);
                    }}
                  />
                </div>

                <div className="col-span-2 flex items-center gap-4">
                  <button
                    onClick={() => getAllBookings(0, rowsPerPage, false)}
                    className="w-12 h-12 rounded-full bg-violet-500 group shadow-xl flex items-center justify-center relative overflow-hidden"
                  >
                    <svg
                      className="w-6 h-6 text-gray-800 relative z-10 dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                      />
                    </svg>

                    <div className="w-full h-full rotate-45 absolute left-[32%] top-[32%] bg-green-500 group-hover:-left-[100%] group-hover:-top-[100%] duration-1000"></div>
                    <div className="w-full h-full -rotate-45 absolute -left-[32%] -top-[32%] group-hover:left-[100%] group-hover:top-[100%] bg-green-500 duration-1000"></div>
                  </button>

                  <button
                    onClick={handleReset}
                    class="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
            border-blue-600
            border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
            active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </Box>

            <Box mb={3}>
              <Paper
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  marginTop: 4,
                  boxShadow: 6,
                  borderRadius: 2,
                  // paddingTop: 2,
                  // paddingLeft: 2,
                  // paddingRight: 2,
                }}
              >
                <TableContainer
                  sx={{
                    overflowX: "auto",
                    overflowY: "100%",
                  }}
                >
                  <Table aria-label="sticky table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        {actionsToAccess?.includes("Assign Sales Agent") && (
                          <TableCell padding="checkbox">
                            <input
                              type="checkbox"
                              indeterminate={
                                selected.length > 0 &&
                                selected.length < rows.length
                              }
                              checked={
                                rows.length > 0 &&
                                selected.length === rows.length
                              }
                              className="cursor-pointer w-4 h-4"
                              onChange={handleSelectAll}
                            />
                          </TableCell>
                        )}
                        {columns.map((column) => (
                          <TableCell
                            sx={{
                              // border: "1px solid #e0e0e0",
                              backgroundColor: "#f5f5f5",
                              display: {
                                xs: column.hideOnMobile ? "none" : "table-cell",
                                sm: "table-cell",
                              },
                            }}
                            style={{ minWidth: column.minWidth }}
                            key={column.id}
                            align={column.align || "left"}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loading ? (
                        <>
                          <TableRow>
                            <TableCell colSpan={columns.length} align="center">
                              <div className="flex flex-col items-center h-40 justify-center">
                                <BlinkBlur
                                  color={[
                                    "#cd8032",
                                    "#32cd32",
                                    "#327fcd",
                                    "#cd32cd",
                                  ]}
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                        </>
                      ) : rows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center">
                            No data found
                          </TableCell>
                        </TableRow>
                      ) : (
                        rows.map((row, idx) => (
                          <TableRow hover key={idx}>
                            {actionsToAccess?.includes(
                              "Assign Sales Agent",
                            ) && (
                              <TableCell padding="checkbox">
                                <input
                                  type="checkbox"
                                  checked={selected.some(
                                    (item) => item.id === row.id,
                                  )}
                                  className="cursor-pointer w-4 h-4"
                                  onChange={(e) => handleSelectRow(e, row)}
                                />
                              </TableCell>
                            )}
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  sx={{
                                    ...(column.id === "isSalesAgentAssigned"
                                      ? {
                                          color: "rgba(16, 17, 17, 0.97)",
                                          fontWeight: 900,
                                        }
                                      : {}),
                                    ...(column.id === "inquiredin"
                                      ? {
                                          color: "#fc7070ff",
                                          fontWeight: 900,
                                        }
                                      : {}),
                                    ...(column.id === "assignedTo"
                                      ? {
                                          color: "rgb(5, 7, 114)",
                                          fontWeight: 900,
                                        }
                                      : {}),
                                    ...(column.id === "source"
                                      ? {
                                          bgcolor: "#ebfff2ff",
                                          fontWeight: 900,
                                        }
                                      : {}),
                                    ...(column.id === "bookingType"
                                      ? {
                                          bgcolor: "rgb(255, 235, 235)",
                                          fontWeight: 900,
                                        }
                                      : {}),
                                    ...(column.id === "bookingstatus"
                                      ? {
                                          color: "#1c1e85ff",
                                          fontWeight: 900,
                                        }
                                      : {}),
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleViewClick(row)}
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.id === "action" ? (
                                    <Button size="small" variant="contained">
                                      View
                                    </Button>
                                  ) : column.id === "bookingCode" ||
                                    column.id === "inquiryID" ||
                                    column?.id === "customermobile" ||
                                    column?.id === "customerEmail" ||
                                    column?.id === "vehicleNo" ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <span>{value || "-"}</span>
                                      {value && (
                                        <>
                                          <ContentCopyIcon
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              navigator.clipboard.writeText(
                                                value,
                                              );
                                              setCopied(value);
                                              setTimeout(
                                                () => setCopied(""),
                                                1500,
                                              );
                                            }}
                                            sx={{
                                              fontSize: 20,
                                              cursor: "pointer",
                                              color:
                                                copied === value
                                                  ? "green"
                                                  : "grey",
                                              transition: "color 0.2s",
                                            }}
                                          />
                                        </>
                                      )}
                                    </Box>
                                  ) : column.format &&
                                    typeof value === "number" ? (
                                    column.format(value)
                                  ) : (
                                    value || "-"
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[20, 30, 40]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    ".MuiTablePagination-toolbar": {
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                    },
                  }}
                />
              </Paper>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Inquirydetailstab
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setOpenTab={setOpenTab}
            getAllBookings={getAllBookings}
            getAllHubsListData={getAllHubsListData}
            setActiveItem={setActiveItem}
            rowsPerPage={rowsPerPage}
            tab="viewAllInquiry"
          />
        </>
      )}
    </>
  );
};

export default Viewallinquiry;
